import { useEffect, useState } from 'react';
import './index.css';
import axios from 'axios';
import { tryCatchJsonParse } from '../../utils/catch/tryCatchJson';
import { use } from 'react';
import { useQueryParms } from '../../hooks/useQueryParams';
import { useNavigate } from 'react-router-dom';
import { sortPlayerByVote } from '../../utils/sortArray';
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import DefaultScreen from '../DefaultScreen';
import HeaderGoldenball from '../GoldenBallVotedScreen/components/HeaderGoldenball';
import { getPositionStatus } from '../GoldenBallVotedScreen/utils/medioTags';
import DescriptionLabel from '../GoldenBallVotedScreen/components/DescriptionLabel';
import GridPlayers from '../GoldenBallVotedScreen/components/GridPlayers';
import { useGetGoldebBallInfo } from '../GoldenBallThrophyScreen/hooks/useGetGoldenBallInfo';
import { useHandlerVoting } from '../GoldenBallVotedScreen/hooks/useHandlerVoting';
import { useVoteRedirect } from '../GoldenBallVotedScreen/hooks/useVoteRedirect';
import useIsMobileAndPortrait from '../../hooks/useIsMobile';
import CarouselPlayers from '../GoldenBallVotedScreen/components/CarouselPlayers';
import LoadingVoteModal from '../GoldenBallVotedScreen/components/LoadingVoteModal';
import ConfirmVoteModal from '../GoldenBallVotedScreen/components/ConfirmVoteModal';



const GoldenballScreen= ()=>{
    const { goldenBallInfo, isLoading } =  useGetGoldebBallInfo({phase:'eleven'})
    const { handleVoteByPlayer, hasSpecialVote, playersVoted, isVoting, selectedPlayer, setSelectedPlayer  } = useHandlerVoting({
                      goldenBallInfo: goldenBallInfo, 
                      phase:'winner'})
     const isVotedEnable = goldenBallInfo?.isEnablePhase?.winner?.vote

  const positions = [
  { key: 'porteros', limit: 1 },
  { key: 'defensaLateral', limit: 2 },
  { key: 'defensasCentral', limit: 2 },
  { key: 'delanteros', limit: 2 },
  { key: 'mediocampistas', limit: 2 },
  { key: 'volantes', limit: 2 }
];

const bestEleven = positions.flatMap(({ key, limit }) =>
  sortPlayerByVote(goldenBallInfo?.onceIdeal?.[key])?.slice(0, limit) || []
);
          useVoteRedirect({
          goldenBallInfo, 
          hasSpecialVote,
          playersVoted,
          targetPath: 'graphScreenGoldenball',
          numberVoted: 1,
  
                      })
          const { isMobile } =  useIsMobileAndPortrait()
    console.log('bestEleven', bestEleven)

    console.log('playerVoted', playersVoted)

    if(isLoading) return <LoadingVoteModal />
    if(!isVotedEnable) return <DefaultScreen title={goldenBallInfo?.name} description={'Se terminaron las votaciones. Gracias, pronto conoceremos al gran ganador.'}  />
    return(
        <div className='golden-ball-voted-screen-container'>         
            <div className='golden-ball-voted-screen-subcontainer'>
            <HeaderGoldenball info={goldenBallInfo} isSpecialVote={hasSpecialVote} />
            <DescriptionLabel phase={'winner'} position={getPositionStatus(playersVoted) }  />
            {
              isMobile ? <CarouselPlayers players={bestEleven} vote={setSelectedPlayer}  /> : <GridPlayers players={bestEleven} vote={setSelectedPlayer}  />
            }

                {
                    selectedPlayer && <ConfirmVoteModal vote={handleVoteByPlayer} player={selectedPlayer} 
                    cancel={() => setSelectedPlayer(null)} />
                }

            {isVoting  && <LoadingVoteModal />}

            

            </div>
        </div>

    )
}

export default  GoldenballScreen